import { render, staticRenderFns } from "./BrewerFilter.vue?vue&type=template&id=75a329e5&"
import script from "./BrewerFilter.vue?vue&type=script&lang=js&"
export * from "./BrewerFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports